import {ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Output,} from "@angular/core";
import {DashboardsService} from "../../services/dashboards.service";
import {AgentRouteScoreModel} from "../../../../agents/angular/models/agent-route-score.model";

require('./dashboard-agents-route-score-table-view.scss');
@Component({
  standalone: false,
  selector: 'app-dashboard-agents-route-score-table-view',
  templateUrl: './dashboard-agents-route-score-table-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardAgentsRouteScoreTableViewComponent implements OnInit {

  @Input() filters: any;
  @Input() data: any;
  @Output() fetchNextEvent = new EventEmitter<null>();

  public agentsRouteScore: AgentRouteScoreModel[];
  public tableCursor: string;
  public isLoadingData: boolean;
  public expandedAgentDetailsMap: any = {};

  constructor(@Inject(DashboardsService) private dashboardsService: DashboardsService) {
  }

  ngOnInit() {
    // this.getTableWidgetData(this._getQueryPayload());
  }

  // getNextBatch() {
  //   if (this.tableCursor) {
  //     let filters = {
  //       ...this._getQueryPayload(),
  //       cursor: this.tableCursor
  //     };
  //     this.getTableWidgetData(filters, true)
  //   }
  // }

  // onToggleExpandAgentDetails(id: string) {
  //
  //   if (!!this.expandedAgentDetailsMap[id]) {
  //     const expandedAgentDetailsMapCopy = {...this.expandedAgentDetailsMap};
  //     expandedAgentDetailsMapCopy[id] = undefined;
  //
  //     this.expandedAgentDetailsMap = expandedAgentDetailsMapCopy;
  //   } else {
  //     this.isLoadingData = true;
  //     this.dashboardsService.getDashboardWidgetData(`${WidgetDatasourceEnum.agentsRoutesScoreDetails}/${id}`, this._getQueryPayload()).subscribe({
  //       next: (res) => {
  //
  //         const expandedAgentDetailsMapCopy = {...this.expandedAgentDetailsMap};
  //         expandedAgentDetailsMapCopy[id] = res;
  //
  //         this.expandedAgentDetailsMap = expandedAgentDetailsMapCopy;
  //         // this.expandedRows[agentId] = true;
  //         // this.agentsRouteScore = res;
  //       },
  //       complete: () => {
  //         this.isLoadingData = false;
  //       }
  //     })
  //   }
  // }

  // private getTableWidgetData(queryParams, isFetchNext?: boolean) {
  //   this.isLoadingData = true;
  //   this.dashboardsService.getDashboardWidgetDataPost(WidgetDatasourceEnum.agentsRoutesScoreDetails, queryParams).subscribe({
  //     next: (res) => {
  //       this.agentsRouteScore = res;
  //     },
  //     complete: () => {
  //       this.isLoadingData = false;
  //     }
  //   })
  // }
  //
  // private _getQueryPayload() {
  //   return {
  //     ...this.filters,
  //     limit: 20
  //   };
  // }


}
